import { createContext } from "react";
import { type AuthUser } from "../api/client";

export interface AuthState {
  user: AuthUser | null;
  status: "loading" | "authenticated" | "unauthenticated";
  setUser: (u: AuthUser | null) => void;
  logout: () => Promise<void>;
}

export const AuthCtx = createContext<AuthState | null>(null);
